import React from 'react';
import styles from './RankDisplay.module.css';

interface RankDisplayProps {
  rank: string; // Format: "3 / 163"
}

/**
 * RankDisplay Component
 *
 * Splits a rank string like "3 / 163" and styles each part differently:
 * - First number (current rank): darker color #000000DE
 * - Separator and total: lighter color #757575
 */
const RankDisplay: React.FC<RankDisplayProps> = ({ rank }) => {
  // Split rank string by "/" and trim whitespace
  const parts = rank.split('/').map(part => part.trim());

  // Handle invalid format gracefully, if there are no two parts then return the original rank
  if (parts.length !== 2) {
    return <span className={styles.rankValue}>{rank}</span>;
  }

  const [currentRank, totalRanks] = parts;

  return (
    <span className={styles.rankValue}>
      <span className={styles.currentRank}>{currentRank}</span>
      <span className={styles.separator}>/</span>
      <span className={styles.totalRanks}>{totalRanks}</span>
    </span>
  );
};

export default RankDisplay;
